$(document).ready(function () {
    var linkCaseBasedLearning   = $('#LinkCaseBasedLearning');
    var unlinkCaseBasedLearning = $('#UnlinkCaseBasedLearning');
    var topic_id                = $(location).attr('href').split('/').reverse()[0];

    $('.linkcasebasedlearning-btn').on('click', function () {
        linkCaseBasedLearning.modal('show');
        $('input[type="hidden"][name="topic_id"]').val(topic_id);
    });

    $('.unlinktopic-btn').on('click', function () {
        unlinkCaseBasedLearning.modal('show');
        var elf = $(this).parents('.elf-row').data('elf');
        $('input[type="hidden"][name="elf_id"]').val(elf.id);
        $('input[type="hidden"][name="topic_id"]').val(topic_id);
        $('h4 span').empty().append(elf.title);
    });
});
